module.exports = __webpack_public_path__ + "static/media/nancy_rios.2ae98edc.png";